import $ from 'jquery';

const colors = ['#F16B5D', '#BEF1EC', '#FFE57C'];

$('.corner').each(function () {
    $(this).css('border-color', colors[Math.floor(Math.random() * colors.length)]);
});

if (document.querySelector('.single-job-posting') && !document.getElementById('job-apply')) {
    $('.sticky-btn').hide();
}

if (document.querySelector('.btn-blue')) {
    const firstBtn = document.querySelector('.btn-blue').offsetTop;
    $(window).on('scroll', function () {
        const viewPosition = $(window).scrollTop();
        if (viewPosition > firstBtn) {
            $('.sticky-btn').addClass('visible');
        } else {
            $('.sticky-btn').removeClass('visible');
        }
    });
}

// function setBtnHeight() {
//     const jobContent = document.getElementsByClassName('job-description-container')[0];
//     const btnSticky = document.getElementsByClassName('sticky-btn')[0];

//     btnSticky.style.setProperty('height', `${jobContent.offsetHeight}px`);
// }

// if ($('.job-description-container')[0]) {
//     $('document').ready(() => {
//         setTimeout(setBtnHeight, 1000);
//     });
// }
